import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { type InboxMode } from '../../../server/types/message-types';
import { MessageService } from '../message.service';

export type ThreadLeaveDialogComponentData = {
  orgId: string;
  refId: string;
  mode: InboxMode;
  parentDialogRef: MatDialogRef<any>;
};

@Component({
  selector: 'app-thread-leave-dialog',
  templateUrl: './thread-leave-dialog.component.html',
  styleUrls: ['./thread-leave-dialog.component.scss'],
  standalone: false,
})
export class ThreadLeaveDialogComponent {
  private dialogRef = inject(MatDialogRef<ThreadLeaveDialogComponent>);
  private readonly data: ThreadLeaveDialogComponentData =
    inject(MAT_DIALOG_DATA);
  private messageService = inject(MessageService);

  orgId: string;
  refId: string;
  mode: InboxMode;
  parentDialogRef: MatDialogRef<any>;

  constructor() {
    this.orgId = this.data.orgId;
    this.refId = this.data.refId;
    this.mode = this.data.mode;
    this.parentDialogRef = this.data.parentDialogRef;
  }

  cancel(): void {
    this.dialogRef.close();
  }

  accept(): void {
    this.messageService.leave({ orgId: this.orgId, refId: this.refId });

    this.dialogRef.close();
    this.parentDialogRef.close();
  }
}
